import * as types from '../types/restaurant';
import {List} from 'immutable';
import * as api from '../constants/';
import axios from 'axios';
import * as appActions from './appActions';
import * as pickUpTimeActions from './pickUpTimeActions';
import {confirmAlert} from 'react-confirm-alert';

function receiveRestaurants(data) {
  return {
    type: types.RESTAURANT_FETCHED,
    data: data,
  };
}

function fetchRestaurant(data, time) {
  return dispatch => {
    dispatch({
      type: types.RESTAURANT_SELECTED,
      data: data,
    });
    return dispatch(pickUpTimeActions.calcAvailableTimes(data, time));
  };
}


export function selectedWithoutFetchRestaurant(data) {
  return dispatch => {
    dispatch({
      type: types.RESTAURANT_SELECTED_WITHOUT_FETCH,
      data: data,
    });
  };
}

export function fetchRestaurants() {
  return dispatch => {
    return axios.get(api.RESTAURANT_URL)
      .then(response => dispatch(receiveRestaurants(List(response.data))));
  };
}

export function selectedRestaurant(id, time) {
  return dispatch => {
    const url = api.RESTAURANT_URL + `${id}/`;
    return axios.get(url).then(response => {
      return dispatch(fetchRestaurant(response.data, time));
    });
  };
}

export function getOrderTimeCooking(id) {
  return dispatch => {
    dispatch({type: types.RESTAURANT_COOK_TIME});
    const url = api.RESTAURANT_URL + `${id}/order/cook-time/`;
    return axios.get(url);
  };
}

export function checkRestaurantIsClosedNow(id, t) {
  return dispatch => {
    dispatch({type: types.RESTAURANT_CHECK});
    const url = api.RESTAURANT_URL + `${id}/check/is-closed/`;
    return axios.get(url).then((response) => {
      if (response.data.success) {
        confirmAlert({
          message: t(`restaurant_${response.data.message}`),
          buttons: [
            {
              label: t('continue'),
              onClick: () => window.location.replace('/'),
            },
          ],
        });
        return Promise.reject();
      }
      return Promise.resolve();
    });
  };
}

export function updateRestaurantOrderTime(data) {
  return dispatch => {
    dispatch({
      type: types.RESTAURANT_UPDATED_ORDER_TIME,
      data: data,
    });
    return dispatch(appActions.getServerTime()).then((response) => {
      return dispatch(pickUpTimeActions.calcAvailableTimes(data, response.data.time));
    });
  };
}

export function startSelectedFetchRestaurant() {
  return dispatch => {
    dispatch({
      type: types.RESTAURANT_START_FETCH,
    });
  };
}

export function endSelectedFetchRestaurant() {
  return dispatch => {
    dispatch({
      type: types.RESTAURANT_END_FETCH,
    });
  };
}



// WEBPACK FOOTER //
// ./src/actions/restaurantActions.js